<template>
<div>
   <el-card class="box-card">
    <div slot="header" class="clearfix" style="text-align:left;">
      <a style="line-height: 36px;margin-left:50px;text-decoration:none;color:#337ab7;cursor:pointer;" target="_blank">设备版本</a>
      <el-button style="float:right;" type="info" @click="showPop(0)">新增</el-button>
    </div>
    <div>
      <el-table
      v-loading="table_loading"
      element-loading-text="拼命加载中"
      :data="deviceData"
      stripe
      border
      fit
      style="width: 100%">
      <el-table-column
        prop="name"
        header-align="center"
        min-width="95"
        label="版本名">
      </el-table-column>
      <el-table-column
        prop="versionCode"
        header-align="center"
        width="90"
        label="版本号">
      </el-table-column>
      <el-table-column
        prop="type"
        header-align="center"
        min-width="95"
        label="设备类型	">
      </el-table-column>
      <el-table-column
        prop="desc"
        header-align="center"
        min-width="160"
        label="版本描述">
      </el-table-column>
      <el-table-column
        prop="url"
        header-align="center"
        min-width="345"
        label="储存位置">
        <template scope="scope">
          <a :href="scope.row.url" style="color: #337ab7;text-decoration: none;">{{scope.row.url}}</a>
        </template>
      </el-table-column>
      <el-table-column
        prop="updatearea"
        header-align="center"
        min-width="95"
        label="更新范围">
      </el-table-column>
       <el-table-column
        prop=""
        header-align="center"
        min-width="105"
        label="状态">
          <template scope="scope">
            <span v-if="scope.row.status === 0">待发布</span>
            <span v-if="scope.row.status === 1">已发布</span>
            <span v-if="scope.row.status === 2">删除</span>
            <span v-if="scope.row.status === 3">暂停</span>
          </template>
      </el-table-column>
       <el-table-column
        prop="updateTime"
        header-align="center"
        min-width="165"
        label="上传时间">
      </el-table-column>
       <el-table-column
        prop="opt"
        header-align="center"
        min-width="135"
        label="操作">
        <template scope="scope">
           <el-button type="text" size="small" @click="removeVersion(scope.row.id,scope.row.name)">删除</el-button>
           <el-button type="text" size="small" v-if="scope.row.updatearea==='区域'" @click="showPop(1,scope.row.url)">单机推送</el-button>
           <el-button type="text" size="small" v-if="scope.row.updatearea==='全局'" @click="updateStatus(scope.row.id,scope.row.status,scope.row.url)">更新状态</el-button>
        </template>
      </el-table-column>
    </el-table>
    </div>
    <div class="table_pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageTotal">
      </el-pagination>
    </div>
  </el-card>
   <pop-adminMgr-add :add-show="myShow" @closeAddAccount="closePop(0)"></pop-adminMgr-add>
   <pop-solo-send :send-show="sendShow" :version-path='versionPath' @closeSendRight="closePop(1)"></pop-solo-send>
   <pop-update-status v-if="updateShow" :the-id="theId" :the-status="theStatus" :the-zippath="theZippath" @closeUpdateStatus="closeUpdateStatus()"></pop-update-status>
  </div>
</template>
<script>
    import $axios from '../../https/config'
    import popAdminAdd from '@/page/versionMgr/popAdminNewAdd'
    import popSoloSend from '@/page/versionMgr/soloSendRightPop'
    import popUpdateStatus from '@/page/versionMgr/popUpdateStatus'

    export default {
      data () {
        return {
          deviceData: [],
          myShow: false,
          sendShow: false,
          versionPath: '',
          theId: '',
          theStatus: '',
          theZippath: '',
          updateShow: false,
          pageTotal: 0,
          pageSize: 10,
          pageNo: 1,
          multipleSelection: '',
          table_loading: false
        }
      },
      created: function () {
        this.pageNo = 1
        this.queryDeviceList(this.pageNo, this.pageSize, '')
      },
      methods: {
        queryDeviceList (tPageNo, tPageSize, tttt) {
          var _this = this
          var params = {
            pageNo: tPageNo,
            pageSize: tPageSize
          }
          this.table_loading = true
          $axios.get('/manager/getVersionList', params, 'headers', function (res) {
            if (res && res.resultStatus === true) {
              var resData = []
              if (res.resultData && res.resultData.list.length > 0) {
                _this.pageTotal = res.resultData.count
                for (var i = 0; i < res.resultData.list.length; i++) {
                  var itemData = res.resultData.list[i]
                  var item = {
                    name: itemData.versionName,
                    versionCode: itemData.versionCode,
                    id: itemData.id,
                    type: itemData.deviceModel,
                    desc: itemData.description,
                    url: itemData.zippath,
                    updatearea: itemData.area === 0 ? '全局' : '区域',
                    status: itemData.status,
                    updateTime: itemData.updateTime
                  }
                  resData.push(item)
                }
                _this.deviceData = resData
              }
            } else {
            }
            _this.table_loading = false
          }, function () {})
        },
        handleSizeChange (val) {
          this.pageSize = val
          this.queryDeviceList(this.pageNo, this.pageSize)
        },
        handleCurrentChange (val) {
          this.pageNo = val
          this.queryDeviceList(this.pageNo, this.pageSize)
        },
        showPop (type, versionPath) {
          if (type === 0) {
            this.myShow = true
          } else if (type === 1) {
            this.sendShow = true
            this.versionPath = versionPath
          }
        },
        closePop (type) {
          if (type === 0) {
            this.myShow = false
          } else if (type === 1) {
            this.sendShow = false
          }
        },
        updateStatus (mId, mStatus, mZippath) {
          this.updateShow = true
          this.theId = mId
          this.theStatus = mStatus
          this.theZippath = mZippath
        },
        closeUpdateStatus () {
          this.updateShow = false
          this.queryDeviceList(this.pageNo, this.pageSize)
        },
        removeVersion (mId, mName) {
          var that = this
          var params = {
            id: mId
          }
          that.$confirm('是否删除该版本，版本' + mName + '将会被删除', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            that.table_loading = true
            $axios.get('/manager/removeVersion', params, 'headers', function (res) {
              if (res && res.resultStatus === true) {
                that.queryDeviceList(that.pageNo, that.pageSize)
                that.$message({
                  type: 'success',
                  message: '删除成功!'
                })
              } else {
              }
              that.table_loading = false
            }, function () {})
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
        }
      },
      components: {
        'pop-adminMgr-add': popAdminAdd,
        'pop-solo-send': popSoloSend,
        'pop-update-status': popUpdateStatus
      }
    }
</script>
<style>
    .table_pagination {
      text-align: right;
      margin-top: 10px; 
    }
</style>


// WEBPACK FOOTER //
// src/page/versionMgr/index.vue